import React, { Component, useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import FlatList from 'flatlist-react';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Typo from '../../components/CustomTypo';
import { Grid, Menu, ListItem, ListItemIcon, ListItemText, Button, TextField } from '@material-ui/core';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import { TimeIcon, BackIcon, MopedIcon, PlaceIcon, PhoneIcon, ErrorIcon, EditWhiteSmallIcon, DeliveryIcon, SuccessIcon } from '../../components/icons'
import GoogleMapComponent from '../../components/GoogleMapComponent';
import GoogleMapMarker from '../../components/GoogleMapMarker';
import Divider from '../../components/Divider'
import { formatDateTimeFrEpoch, formatTimeFrEpoch } from '../../utils/util';
import Container from '../../components/Container';
import { clearOrder, getOrderCache, order_key, setOrderCache } from '../../utils/order_cache';
import { callCartItemListeners, callRefreshMyOrderListeners, getCurrency, getLogo } from '../../utils/common';
import crmservices from '../../wsclient/crmservices';
import ModalAlert from '../../components/ModalAlert';

function ProcessOrderSecure(props) {
    const [showLoading, onShowLoading] = useState(false);
    const [message, setMessage] = useState({});
    const [orderResult, setOrderResult] = useState(undefined);
    const [isOrderSuccess, setOrderSuccess] = useState(undefined);
    const [ready, setReady] = useState(false);

    const carts = getOrderCache(order_key.cart);
    const contact_phone = getOrderCache(order_key.contact_phone_order);
    const delivery_address = getOrderCache(order_key.delivery_address);
    const order_type = getOrderCache(order_key.order_type, true);
    const estimate_order_result = getOrderCache(order_key.estimate_order_result);
    const pick_up_store = getOrderCache(order_key.pick_up_store);
            
    useEffect(()=>{
        init();
    },[])

    const init = async() =>{
        onShowLoading(true);
        let path = window.location.pathname;
        let token = getOrderCache(order_key.order_token);
        //let arr = path.split('/');
       // console.log('ProcessOrderSecure path.search(token)', path.search(token));
        if(path && path.search(token)>0){
            setReady(true);
            await processMakeOrder();
            onShowLoading(false);
        }
    }

    const processMakeOrder = async() =>{
        try {
            //console.log("wi aaaa:", window.location.pathname);
            let pathName = window.location.pathname;
            if (pathName.includes('success')) {
                let payload = getOrderCache(order_key.cache_order_to_be_process);
                var result = await crmservices.orders.makeOrder(payload);
                if (result.code == 'OK') {
                    var orderResult = result.data;
                    var orderDetail = await crmservices.orders.getOrder(result.data.id);
                    if (orderDetail.code === 'OK') {
                        orderResult = { ...orderResult, ...orderDetail.data };
                    }
                    callRefreshMyOrderListeners();
                    clearOrder();
                    callCartItemListeners();
                    setOrderSuccess(true);
                    setOrderResult(orderResult);

                    setOrderCache(order_key.order_status, 'DONE', true)
                } else if (result.code == 'MINIMUM_ORDER_AMOUNT_NOT_REACHED') {
                    setOrderSuccess(false);
                    showMessage(true, props.t('MINIMUM_ORDER_AMOUNT_NOT_REACHED'))
                } else {
                    setOrderSuccess(false);
                    showMessage(true, props.t('EXCEPTION_PROCESS'));
                }
            } else {
                setOrderSuccess(false);
                showMessage(true, props.t('EXCEPTION_PROCESS'));
            }
        } catch (error) {
            setOrderSuccess(false);
            console.log("make order exception:", error);
            showMessage(true, props.t('EXCEPTION_PROCESS'));
        }
    }
    const showMessage = async(status, message) =>{
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null
        });
    }
    const getComponent = (items) =>{
        var componentStr = '';
        items.forEach(item => {
            componentStr = componentStr + item.name + ", ";
        });
        if (componentStr) {
            componentStr = componentStr.substr(0, componentStr.length - 2);
        }
        return componentStr;
    }
    const getVariant = (items) =>{
        var variantStr = '';
        items.forEach(item => {
            variantStr = variantStr + item.value + ", ";
        });
        if (variantStr) {
            variantStr = variantStr.substr(0, variantStr.length - 2);
        }
        return variantStr;
    }
    const { classes, t } = props;
    var estimated_delivery = estimate_order_result && estimate_order_result.order_estimate && estimate_order_result.order_estimate.estimated_delivery ? estimate_order_result.order_estimate.estimated_delivery : null;
    var deliveredAtOrg = estimated_delivery && estimated_delivery.delivered_at ? formatDateTimeFrEpoch(estimated_delivery.delivered_at, true) : "";
    var time_to_deliver = estimated_delivery && estimated_delivery.time_to_delivery ? estimated_delivery.time_to_delivery : "";
    if (time_to_deliver)
        time_to_deliver = time_to_deliver + " " + (estimated_delivery.uot ? estimated_delivery.uot + 'S' : "");
    
        

    var delivered_by = estimate_order_result && estimate_order_result.order_estimate && estimate_order_result.order_estimate.fulfilled_by
        ? estimate_order_result.order_estimate.fulfilled_by.name : "";
    var pickup_address = pick_up_store && pick_up_store.address ? pick_up_store.address.address_line_1
        + (pick_up_store.address.town_city ? ', ' + pick_up_store.address.town_city : '')
        + (pick_up_store.address.state_province_county ? ', ' + pick_up_store.address.state_province_county : '')
        + (pick_up_store.address.postal_code ? ', ' + pick_up_store.address.postal_code : '')
        : ''
    var deleveryItem = null;
    if (estimate_order_result && estimate_order_result.invoice_estimate && estimate_order_result.invoice_estimate.line_items && estimate_order_result.invoice_estimate.line_items.length > 1) {
        deleveryItem = dataUtil.getDeliveryItem(estimate_order_result.invoice_estimate.line_items);
    }

    let currency = getCurrency();
    if(ready)
        return (
            <Container showLoading={showLoading}>
                <Grid xs={12} item justify='center' container>
                    <Grid xs={12} sm={12} md={8} lg={6} item>
                        <Grid xs={12} item style={{ height: '40vh' }}>
                            <OrderMap
                                delivery_address={delivery_address}
                                pick_up_store={pick_up_store}
                                order_type={order_type}
                            />
                        </Grid>
                        <Grid xs={12} item>
                            <Grid xs={12} item justify='center' container style={{ marginTop: 16 }}>
                                {isOrderSuccess == true && <SuccessIcon style={{ width: 100, height: 100 }} />}
                                {isOrderSuccess == false && <ErrorIcon style={{ width: 100, height: 100 }} />}
                            </Grid>
                            <Grid xs={12} item justify='center' container style={{ marginBottom: 16 }}>
                                {isOrderSuccess && <Typo color="onPrimary" variant="subtitle1" mg_top_xl>{t("order_placed")}</Typo>}
                                {isOrderSuccess == false && <Typo color="onPrimary" variant="subtitle1" mg_top_xl>{'Order failed'}</Typo>}
                            </Grid>
                            <Grid xs={12} item className={classes.container}>
                                {order_type === 'DELIVERY' && <ListItem alignItems="flex-start">
                                    <ListItemIcon className={classes.listItemIconRoot}>
                                        <PlaceIcon />
                                    </ListItemIcon>
                                    <ListItemText>
                                        <Typo color="onPrimary" variant="body2">{t('order_to_be_fulfilled_by')}</Typo>
                                        <Typo mg_top_xs color="default" variant="body2">{delivered_by}</Typo>
                                    </ListItemText>
                                </ListItem>}
                                {order_type === 'DELIVERY' && <Divider variant="inset" component="li" />}
                                {contact_phone && contact_phone.number && <ListItem alignItems="flex-start">
                                    <ListItemIcon className={classes.listItemIconRoot}>
                                        <PhoneIcon />
                                    </ListItemIcon>
                                    <ListItemText >
                                        <Typo color={"default"} variant="body2">{contact_phone.number}</Typo>
                                    </ListItemText>
                                </ListItem>}
                                <Divider variant="inset" component="li" />
                                <ListItem alignItems="flex-start">
                                    <ListItemIcon className={classes.listItemIconRoot}>
                                        {order_type == 'DELIVERY' ? <MopedIcon /> : <PlaceIcon />}
                                    </ListItemIcon>
                                    {order_type == 'DELIVERY' ? <ListItemText>
                                        <Typo color="default" variant="body2">{delivery_address.address_line_1}</Typo>
                                    </ListItemText> :
                                        <ListItemText>
                                            <Grid item xs={12} container >
                                                <Grid item xs={8}>
                                                    <Typo color="onPrimary" variant="body2">{pick_up_store.name}</Typo>
                                                    <Typo color="default" variant="body2">{pickup_address}</Typo>
                                                </Grid>
                                                <Grid item xs={4} container alignItems='center' justify='flex-end'>
                                                    <PhoneIcon />
                                                    <Typo color="default" variant="body2" mg_right_xl>{pick_up_store.phone ? pick_up_store.phone : ''}</Typo>
                                                </Grid>
                                            </Grid>
                                        </ListItemText>}
                                </ListItem>
                                <Divider variant="inset" component="li" />
                                {estimated_delivery && <Grid item><ListItem alignItems="flex-start" >
                                    <ListItemIcon className={classes.listItemIconRoot}>
                                        <TimeIcon />
                                    </ListItemIcon>
                                    <ListItemText>
                                        {/* <Typo color="onPrimary" variant="body2">{order_type === 'DELIVERY' ? t('expected_delivery_time') : t('expected_preparation_time')}</Typo> */}
                                        <Typo mg_top_xs color="default" variant="body2">{deliveredAtOrg}</Typo>
                                    </ListItemText>
                                </ListItem>
                                    <Divider variant="inset" component="li" />
                                </Grid>}
                            </Grid>
                            <Grid xs={12} item className={classes.listItem}>
                                <Typo color="onPrimary" variant="subtitle1">{t("order_items")}</Typo>
                            </Grid>
                            {carts && carts.length && <InfiniteScroll dataLength={carts.length} height={'66vh'}>
                                <Grid xs={12} item className={classes.listItem}>
                                    <OrderItem items={carts} classes={classes} currency={currency} getVariant={getVariant} getComponent={getComponent} />
                                    {deleveryItem && <Grid xs={12} item container direction="row" className={classes.item} alignItems='center'>
                                        <Grid xs={1} item>
                                            <div className={classes.item_icon_container}>
                                                <DeliveryIcon />
                                            </div>
                                        </Grid>
                                        <Grid xs={1} item container />
                                        <Grid xs={6} item>
                                            <Typo color="onPrimary" variant='body2'>{deleveryItem.product.name}</Typo>
                                        </Grid>
                                        <Grid xs={4} item container justify='flex-end'>
                                            <Typo color="onPrimary" variant='body2'>{currency}{deleveryItem.unit_price ? deleveryItem.unit_price.toFixed(2) : "0.00"}</Typo>
                                        </Grid>
                                    </Grid>}
                                </Grid>
                                <Grid xs={12} item container direction="row" alignItems="flex-end" className={classes.row}>
                                    <Grid xs={6} item>
                                        <Typo mg_top_sm variant='body2' color='onPrimary'>{t('total')}:</Typo>
                                    </Grid>
                                    <Grid xs={6} item container justify='flex-end'>
                                        <Typo mg_top_sm variant='h6' color='onPrimary'>{currency}{estimate_order_result && estimate_order_result.invoice_estimate ? estimate_order_result.invoice_estimate.amount_due.toFixed(2) : "0.00"}</Typo>
                                    </Grid>
                                </Grid>
                            </InfiniteScroll>}
                        </Grid>
                    </Grid>
                </Grid>
                {message && <ModalAlert
                    open={message.show}
                    onClose={showMessage}
                    message={message.content}
                />}
            </Container >
        );
    else{
        return(
            <Container showLoading={showLoading}>

            </Container>
        )
    }    
}

function OrderMap(props) {
    const { delivery_address, pick_up_store, order_type } = props;
    return (
        <GoogleMapComponent>
            <GoogleMapMarker
                info={{ title: order_type == 'DELIVERY' ? delivery_address.address_line_1 : pick_up_store.name, description: order_type == 'DELIVERY' ? "" : (pick_up_store.address ? pick_up_store.address.address_line_1 : ' ') }}
                key={1}
                lat={order_type == 'DELIVERY' ? delivery_address.lat : (pick_up_store.address ? pick_up_store.address.lat : null)}
                lng={order_type == 'DELIVERY' ? delivery_address.lon : (pick_up_store.address ? pick_up_store.address.lon : null)}
            />
        </GoogleMapComponent>
    )
}

function OrderItem(props) {
    var classes = props.classes;
    return <FlatList
        list={props.items}
        renderItem={(item) =>
            <Grid xs={12} item container direction="row" className={classes.item} alignItems='center'>
                <Grid xs={1} item>
                    <div className={classes.item_image_container}>
                        <ItemImage classes={classes} image={dataUtil.getImageByUsageTypePortal(item.creatives, usage_type.product_item)} />
                    </div>
                </Grid>
                <Grid xs={1} item container>
                    <Typo color="default" variant='body2'>{item.quantity}x</Typo>
                </Grid>
                <Grid xs={6} item>
                    <Grid xs={12} item>
                        <Typo color="onPrimary" variant='body2'>{item.name}</Typo>
                    </Grid>
                    {item.variant_selected && <Grid xs={12} item><Typo variant='description' color='onPrimary'>{props.getVariant(item.variant_selected)}</Typo></Grid>}
                    {item.components && <Grid xs={12} item><Typo color="default" variant='description'>{props.getComponent(item.components)}</Typo></Grid>}
                </Grid>
                <Grid xs={4} item container justify='flex-end'>
                    <Typo color="onPrimary" variant='body2'>{props.currency}{item.totalAmount.toFixed(2)}</Typo>
                </Grid>
            </Grid>
        }
    />
}

function ItemImage(props) {
    if (props.image && props.image.url) {
        return <img className={props.classes.item_image} src={props.image.url} />
    } return <img className={props.classes.item_image} src={getLogo()} />;
}

const styles = theme => ({
    content: {
        margin: theme.spacing(4, 0, 4, 0)
    },
    footer: {
        position: 'fixed',
        bottom: theme.spacing(5),
        width: '47%',
        [theme.breakpoints.down('md')]: {
            width: '54%'
        },
        [theme.breakpoints.down('sm')]: {
            width: '63%'
        },
        [theme.breakpoints.down('xs')]: {
            width: '81%'
        }
    },
    row: {
        margin: theme.spacing(2, 0, 2, 0)
    },
    item_image: {
        width: theme.spacing(9),
        height: theme.spacing(9),
        objectFit: 'containt',
        borderRadius: theme.spacing(9),
    },
    item_image_container: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        borderRadius: theme.spacing(10),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing(5),
        backgroundColor: theme.palette.background.secondary,
    },
    listItem: {
        marginTop: theme.spacing(7)
    },
    item: {
        margin: theme.spacing(5, 0, 5, 0)
    },
    item_icon_container: {
        // marginLeft: 10,
        width: 40,
        height: 40,
        borderRadius: 40,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing(5) + 10,
        backgroundColor: theme.palette.button.category.backgroundColor,
    },
});
export default withStyles(styles)(withTranslation()(ProcessOrderSecure));